import React, { lazy, Suspense } from "react";
import { Provider } from "react-redux";
import { store, persistor } from "../src/redux/store";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./index.css";
import { render } from "react-dom";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { msalInstance } from "./msalConfig";
import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeContextProvider } from "./context/ThemeContext";
import "./i18n";
import LanguageInitializer from "./i18n";
const App = lazy(() => import("./App"));

const theme = createTheme({
  typography: {
    fontFamily: ["Lato", "sans-serif"].join(","),
  },
});

render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={null}>
            <SnackbarProvider autoHideDuration={2500}>
              <BrowserRouter>
                <MsalProvider instance={msalInstance}>
                  <GoogleOAuthProvider
                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                  >
                    <ThemeContextProvider>
                      <LanguageInitializer />
                      <App />
                    </ThemeContextProvider>
                  </GoogleOAuthProvider>
                </MsalProvider>
              </BrowserRouter>
            </SnackbarProvider>
          </Suspense>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
